/**
 * Formats a date string into the specified format.
 *
 * @param {string} dateString - The date string to format.
 * @param {string} [format='DD/MM/YYYY'] - The format to use for the date. Defaults to 'DD/MM/YYYY'.
 * @returns {string} - The formatted date string.
 *
 */
export const formatDateString = (dateString: string, format: string = 'DD/MM/YYYY') => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return format.replace('DD', day).replace('MM', month).replace('YYYY', String(year));
};

/**
 * Checks if the given date string is greater than or equal to today's date.
 *
 * @param {string} dateString - The date string to check.
 * @returns {boolean} - True if the date is greater than or equal to today, false otherwise.
 */
export const isDateTodayOrFuture = (dateString: string): boolean => {
    const givenDate = new Date(dateString);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Set today's time to midnight for accurate comparison
    const result = givenDate >= today;
    return result;
};
